const websiteId = process.env.REACT_APP_UMAMI_WEBSITE_ID;
const dashboardUrl = process.env.REACT_APP_ANALYTICS_DASHBOARD_URL;

const pendingCalls = [];
const MAX_PENDING_CALLS = 100;

const flushPendingCalls = () => {
  const calls = pendingCalls.splice(0);
  for (const call of calls) {
    try {
      call();
    } catch (_error) {
    }
  }
};

const enqueue = (call) => {
  if (pendingCalls.length < MAX_PENDING_CALLS) {
    pendingCalls.push(call);
  }
};

if (websiteId && websiteId !== '') {
  const existing = document.querySelector(`script[data-website-id="${websiteId}"]`);
  if (!existing) {
    const s = document.createElement('script');
    s.async = true;
    s.defer = true;
    s.src = '/analytics/script.js';
    s.setAttribute('data-website-id', websiteId);
    s.setAttribute('data-host-url', window.location.origin + '/analytics');
    s.addEventListener('load', flushPendingCalls);
    document.head.appendChild(s);
  }
}

if (dashboardUrl && dashboardUrl !== '') {
  window.__ANALYTICS_DASHBOARD_URL__ = dashboardUrl;
}

const trackEvent = (eventName, eventData) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (typeof window.umami?.track === 'function') {
    try {
      window.umami.track(eventName, eventData);
    } catch (_error) {
    }
  } else {
    enqueue(() => trackEvent(eventName, eventData));
  }
};

const identifyVisitor = (traits) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (typeof window.umami?.identify === 'function') {
    try {
      window.umami.identify(traits);
    } catch (_error) {
    }
  } else {
    enqueue(() => identifyVisitor(traits));
  }
};

export { websiteId, dashboardUrl, trackEvent, identifyVisitor };
